export enum InstrumentStatusNamesEnum {
  DRAFT = 'Draft',
  PUBLISHED = 'Published',
  LIVE = 'Live',
}
